import { ResourceManagerRule, ResourceType, RuleConsequenceCreateObject } from '../../../backend';

export const initialValues: ResourceManagerRule = {
    conditions: {
        conditionOnObjects: [
            {
                condition: {} as any, // TODO Fix form type
                objectType: '',
                variableName: '',
            },
        ],
    },
    consequence: {
        type: 'RuleConsequenceCreateObject',
        objectType: 'ResourceScore',
        objectFields: {
            flight: { type: 'VariableFieldOperand', variable: '', field: 'id' },
            resource: { type: 'TextOperand', value: '' },
            rule: { type: 'TextOperand', value: '' },
            score: { type: 'NumberOperand', value: 0 },
        },
    } as RuleConsequenceCreateObject,
    name: null,
    salience: '0',
    activated: true,
    resourceType: ResourceType.PARKING,
    type: 'ResourceManagerRule',
};
